module.exports = __webpack_public_path__ + "static/media/Murugappa_Group_Logo_1576922020749.fff1d628.png";